module.exports = __webpack_public_path__ + "img/9788961570879.6d48f823.jpg";